import { Paper, Typography, Box, Modal } from "@mui/material";
import TableMuiCustom from "../mui/TableMuiCustom";
import { styled } from '@mui/system';
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { selectnodess } from "../redux/nodesSlice";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    overflow: "auto", // Ensure no scrollbars appear on the outer box
    maxHeight: "90vh",
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
}));

export function ShowBranchesModel({
   
    handleClose,
    open,
    setdatafordelete,
    setOpenDeleteModal,
    setDeleteopen,
    node,
    setnode,
    setnodefordelete,
    setBranchCount
}) {
    const allorganization = useSelector(selectnodess) || [];
    const closeModel = () => {
        handleClose(false)
    }
    //// console.log(node, "nodedata");
    //// console.log(allorganization, "allorg");

    const [data, setData] = useState([])

    useEffect(() => {
        // Find the node with node.nodeId
        const shareHolderNode = Array.isArray(allorganization) && allorganization.find((item) => item.id === node.nodeId);

        //// console.log(shareHolderNode, "shareHolderNode");

        if (shareHolderNode && Array.isArray(shareHolderNode.children)) {
            // Extract children IDs
            //// console.log(shareHolderNode.children);
            const childrenIds = shareHolderNode?.children?.map(child => child._id.toString());    
            //// console.log(childrenIds, "childrenIds");
            // Filter organizations by children IDs
            const filteredOrganizations = allorganization?.filter(organization =>
                childrenIds?.includes(organization.id)
            );
            //// console.log(filteredOrganizations, "filteredOrganizations");
            setdatafordelete(filteredOrganizations)
            const allbraches=filteredOrganizations?.filter((item)=>item.isBranch===true);
            setData(allbraches?.map((org, index) => ({
                ...org,
                data: {
                    ...org.data,
                    index: index + 1,

                },
            })))
} else {
    // console.log("shareHolderNode does not have children array or it's not an array");
}
    
 }, [allorganization, node]);






return (
    <React.Fragment>
        <Modal
            open={open}
            onClose={closeModel}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box sx={style}>

                <Typography variant="h5" className="text-center" id="child-modal-description" gutterBottom>
                   Branches : {data.length}
                </Typography>
              { data && data.length>0? <TableMuiCustom
                    styleTableTh={{ fontWeight: "bold" }}
                    styleTableContainer={{ minWidth: "400px" }}
                    TableHead={{
                        borderRadius: "10px",
                        color: "black",
                        fontWeight: "bold",
                    }}
                    styleTableThead={{
                        backgroundColor: "white",
                        color: "black",
                        fontWeight: "bold",
                    }}
                    th={{
                        companyName: "Company Name",
                        deleteBtn: <div className="text-end">delete</div>,
                    }}
                    td={data}
                    customFields={[
                        {
                            name: "deleteBtn",
                            data: (value, row) => (
                              <Box className="d-flex justify-content-end align-items-center">
                                <DeleteIcon style={{ fontSize: "30px", color: "#1976d2", cursor: "pointer" }} onClick={() => {
                                  setnodefordelete(row)
                                  setOpenDeleteModal(true)
                                  setDeleteopen(true)
                                //   handleClose(false)
                                }} />
                              </Box>
                            ),
                          },
                    ]}
                />:""}
            </Box>
        </Modal>
    </React.Fragment>
);
}
